import template from "@/views/Layout/template.vue";
import Course from "@/views/Course/index";
import StudentsManage from "@/views/students/index";
import QuestionBank from "@/views/QuestionBank/index";
import Message from "@/views/Message/index";
import Role from "@/views/system/Role/index";
import user from "@/views/system/User/index";
import Dict from "@/views/system/Dict/index";
import Menu from "@/views/system/Menu/index";

/** 静态业务路由（接口动态路由失败时的兜底，也可与动态路由合并） */
export const asyncRoutes = [
  {
    name: "课程管理",
    path: "/course",
    component: template,
    meta: {
      title: "课程管理",
      requireAuth: true
    },
    children: [
      {
        path: "index",
        name: "课程中心",
        component: Course,
        meta: {
          title: "课程中心",
          requireAuth: true
        }
      }
    ]
  },
  {
    name: "学员管理",
    path: "/student",
    component: template,
    meta: {
      title: "学员管理",
      requireAuth: true
    },
    children: [
      {
        path: "index",
        name: "学员中心",
        component: StudentsManage,
        meta: {
          title: "学员中心",
          requireAuth: true
        }
      }
    ]
  },
  {
    name: "题库管理",
    path: "/question",
    component: template,
    meta: {
      title: "题库管理",
      requireAuth: true
    },
    children: [
      {
        path: "theory",
        name: "理论题库",
        component: QuestionBank,
        meta: {
          title: "理论题库",
          requireAuth: true
        }
      },
      {
        path: "practical",
        name: "实操题库",
        component: QuestionBank,
        meta: {
          title: "实操题库",
          requireAuth: true
        }
      }
    ]
  },
  {
    name: "消息管理",
    path: "/message",
    component: template,
    meta: {
      title: "消息管理",
      requireAuth: true
    },
    children: [
      {
        path: "index",
        name: "消息中心",
        component: Message,
        meta: {
          title: "消息中心",
          requireAuth: true
        }
      }
    ]
  }
];

export const systemRoutes = {
  path: "/system",
  name: "系统管理",
  meta: {
    title: "系统管理",
    requireAuth: true
  },
  children: [
    {
      path: "role",
      name: "角色中心",
      component: Role,
      meta: {
        title: "角色中心",
        requireAuth: true
      }
    },
    {
      path: "user",
      name: "用户中心",
      component: user,
      meta: {
        title: "用户中心",
        requireAuth: true
      }
    },
    {
      path: "dict",
      name: "数据字典",
      component: Dict,
      meta: {
        title: "数据字典",
        requireAuth: true
      }
    },
    {
      path: "menu",
      name: "菜单管理",
      component: Menu,
      meta: {
        title: "菜单管理",
        requireAuth: true
      }
    }
  ]
};



// WEBPACK FOOTER //
// ./src/router/asyncRoutes.js